<template>
	<div data-tour-scope="customers-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.customers.list') }} </v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--<v-btn text :href="linkdownload+'?search='+searchfield+'&categories='+settings.filters.categories+'&selected='+selected" exact >
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->
								<!--<v-btn text
                                       :href="this.getUrl+'items/download?token='+this.getToken+'&search='+this.searchfield+'&filters='+this.settings.filters+'&selected='+this.selected"
                                       exact>
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->
								<!--<v-btn text @click="toggleDrawerSort">
                                    <v-icon>mdi-sort</v-icon>
                                </v-btn>-->
								<!-- <v-divider vertical></v-divider>-->
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text>
											<v-icon>mdi-arrow-collapse-down</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<!--<v-list-item @click="getCategoryMagento" v-if="magento">
                                            <v-list-item-icon>
                                                <v-icon>mdi-plus</v-icon>
                                            </v-list-item-icon>

                                            <v-list-item-content>
                                                <v-list-item-title>Importa da Magento</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>-->
										<v-list-item @click="exportAsync('customers', 'csv', { search: searchfield, selected: selectedchecbox })">
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Esporta in CSV</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
								<!-- <v-divider vertical></v-divider>-->
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Aggiungi cliente" data-tour="add-customer" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="4">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-autocomplete v-model="settings.filters.listing" :items="selectListings" label="Listino" item-value="_id" item-text="name" dense clearable outlined hide-details></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4">
									<v-select label="Customer Type" v-model="settings.filters.type" item-value="value" item-text="name" :items="customersType" dense clearable outlined hide-details></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!--:hide-default-header="isMobile"
                            :class="{mobile: isMobile}"-->

							<!-- <template slot="headers" slot-scope="props">
                                 <tr>
                                     <th>
                                         <v-checkbox
                                                 primary
                                                 hide-details
                                                 @click.native="toggleAll"
                                                 :input-value="props.all"
                                                 :indeterminate="props.indeterminate"
                                         ></v-checkbox>
                                     </th>
                                     <th v-for="header in props.headers" :key="header.text"
                                         :class="['column sortable', settings.pagination.descending ? 'desc' : 'asc', header.value === settings.pagination.pagination.sortBy ? 'active' : '']"
                                         @click="changeSort(header.value)"
                                     >
                                         <v-icon>arrow_upward</v-icon>
                                         {{ header.text }} f
                                     </th>
                                 </tr>
                             </template>-->
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="customer-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="titoloCard(item)" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Attivo</span>
													<v-switch v-model="item.active" data-tour="status" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
											<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
											<v-list-item data-tour="row-edit" @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item data-tour="row-delete" @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>
									<v-switch v-model="item.active" data-tour="status" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
										</td>
										<td>
											{{ item.created_at | moment('DD/MM/YYYY') }}
										</td>
										<td>
											{{ item.type }}
											<!---->
										</td>
										<td>
											{{ item.buyer?.name }}
											<!---->
										</td>
										<td>
											{{ item.buyer?.lastname }}
										</td>
										<td>
											{{ item.buyer?.email }}
										</td>
										<td>{{ item.InvoiceAddress?.Company }}</td>

										<td>{{ item.InvoiceAddress?.Vat }}</td>
										<td>{{ convertListing(item.listing) }}</td>
										<td>{{ formatWallet(item.wallet) }}</td>

										<!--td>{{ item.id }}</td-->
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
					<!--<v-btn
                            fab
                            bottom
                            right
                            color="secondary"
                            dark
                            fixed
                            @click.prevent="openNew()"
                    >

                        <v-icon>add</v-icon>
                    </v-btn>-->
				</v-layout>
			</v-container>
		</v-main>
		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando la categoria non potrai più ripristinarla. I prodotti associati resteranno senza categoria </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';

Vue.use(VuetifyDraggableTreeview);
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { createCustomersListTourSteps, stopCustomersListTour } from './customers-list-tour';


// sotto i 4 caratteri il backend ignora la ricerca
const SEARCH_MIN = 4;
const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Items',
	// pagina, righe, ordinamento, ricerca, listino e tipo stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ filters: { listing: 'string', type: 'string' }, perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createCustomersListTourSteps(), { onStop: stopCustomersListTour }) };
	},
	data() {
		return {
			menu: false,
			customersType: [
				{ name: 'Private', value: 'private' },
				{ name: 'Company', value: 'company' },
			],
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			items: [],
			selectedchecbox: [],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca: default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					type: '',
					listing: '',
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			listSize: LIST_SIZE,
			searchfield: '',
			total: 0,
			headers: [
				// colonna del menu a tre puntini: non si ordina (ordinava per un campo vuoto e la lista restava in caricamento)
				{ text: '', value: '', sortable: false },
				{ text: 'Active', value: 'active', sortable: true },
				{ text: 'Created', value: 'created_at', sortable: true },
				{ text: 'Type', value: 'type', sortable: true },
				{ text: 'Name', value: 'buyer.name', sortable: true },
				{ text: 'Lastname', value: 'buyer.lastname', sortable: true },
				{ text: 'Email', value: 'buyer.email', sortable: true },
				{ text: 'Company', value: 'InvoiceAddress.Company', sortable: true },
				{ text: 'Vat', value: 'InvoiceAddress.Vat' },
				{ text: 'Listing', value: 'listing' },
				{ text: 'Wallet', value: 'wallet', sortable: true },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			dialogconfirm: false,
			dialogconfirmImport: false,
			isActive: true,
			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,
			isMobile: false,
			operation: '',
			magento: false,
			shopify: false,
			langDefault: '',
			brands: [],
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			selectListings: [],
			// letto qui, prima che il mixin della lista riscriva l'URL (dove la ricerca diventa `q`)
			autoOpenSearch: this.$route.query.search || null,
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return (value = value.toFixed(2));
		},
	},
	created() {
		this.setExistFilter(true);

		// /customers?search=<email> (link dal Carrello): si filtra per quell'email e, se il cliente
		// e' uno solo, se ne apre la pagina. Nell'URL la ricerca diventa poi `q` come nelle altre liste.
		if (this.autoOpenSearch) {
			this.searchfield = this.autoOpenSearch;
			this.settings.search = this.autoOpenSearch;
		}
		this.listLoad();

		this.fetchSetting().then(data => {
			this.langDefault = _.find(data.languages, { default: true }).lang;
		});
		this.getListings().then(res => {
			_.forEach(res.data, el => {
				this.selectListings = [{ _id: el._id, name: el.name }, ...this.selectListings];
			});
		});
	},
	watch: {
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		TourOverlay,
		KeyValueCard,

		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'customers/getIndex',
			getItems: 'customers/getItems',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'customers/getSortBy',
			getSortDesc: 'customers/getSortDesc',
			getSettings: 'settings/getSetting',
		}),

		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function (old, newvalue) {
				return this.clippedOrder;
			},
			set: function (newvalue) {
				return this.clippedOrder;
			},
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setItems: 'customers/setItems',
			setItem: 'customers/setItem',
			setIndex: 'customers/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'customers/asyncFetchData',

			deleteItems: 'customers/deleteItems',
			destroyData: 'customers/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			getListings: 'listings/getListings',

			//'resetMessages' : 'settings/resetMessages'
		}),


		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		// inserimento e modifica sono pagine (si apre solo dalla riga, tre puntini):
		// la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.setClearError({});
			this.setMessages();
			this.$router.push(`/customers/${item._id}`);
		},
		// titolo della card: nome e cognome, altrimenti ragione sociale o email
		titoloCard(item) {
			const nome = `${item.buyer?.name || ''} ${item.buyer?.lastname || ''}`.trim();
			return nome || item.InvoiceAddress?.Company || item.buyer?.email || 'Cliente';
		},
		// coppie chiave/valore della card (vista telefono); azienda e P.IVA solo se presenti
		campiCard(item) {
			return [
				{ label: 'Creato', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Tipo', value: item.type },
				{ label: 'Email', value: item.buyer?.email },
				{ label: 'Azienda', value: item.InvoiceAddress?.Company, opzionale: true },
				{ label: 'P.IVA', value: item.InvoiceAddress?.Vat, opzionale: true },
				{ label: 'Listino', value: this.convertListing(item.listing) },
				{ label: 'Wallet', value: this.formatWallet(item.wallet), strong: true },
			]
				.filter(campo => !campo.opzionale || campo.value)
				.map(({ label, value, strong }) => ({ label, value, strong }));
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},
		createItem() {
			this.setClearError({});
			this.setMessages();
			this.$router.push('/customers/new');
		},
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
		},
		convertListing(_id) {
			if (_id != '') {
				var check = _.find(this.selectListings, { _id: _id });
				if (check) {
					return check.name;
				} else {
					return '';
				}
			}
		},
		formatWallet(value) {
			const wallet = Number(value) || 0;
			return wallet.toFixed(2);
		},

		async changeStatus(item) {
			try {
				this.setPreload(true);
				let url = 'customers/update-status';

				axios
					.post(`${this.getUrl}${url}`, { _id: item._id, active: item.active }, { headers: { Authorization: `Bearer ${this.getToken}` } })
					.then(({ data }) => {
						if (data.data._id) {
							this.snackbar.color = 'success';
							this.snackbar.text = 'Update successfully';
							this.snackbar.snackbar = true;
							this.snackbar.mode = 'multi-line';
							this.snackbar.timeout = 5000;
						}
					})
					.catch(err => {
						if (err.response) {
							let errors = err.response.data.error;
							if (errors) {
								console.log(errors);

								var testo = '';
								errors.forEach(value => {
									//   console.log(value.msg);
									var spliterror = _.split(value.param, '.');
									this.messages[spliterror[1]] = value.msg;
									testo += value.msg + ' <br>';
								});
							}

							this.snackbar.color = 'error';
							//this.snackbar.text = this.$vuetify.lang.t(`$vuetify.errors.${err.response.data.message}`);
							this.snackbar.text = testo;
							this.snackbar.snackbar = true;
							this.snackbar.mode = 'multi-line';
							this.snackbar.timeout = 5000;
							this.setPreload(false);
							if (err.response.status === 401) {
								this.setLogout();
								this.$router.push('/login');
							}
						}
					});

				this.setPreload(false);
			} catch (e) {
				console.log(e.message);
			}
		},

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;

				let items = this.fetchItems(this.settings);
				items
					.then(result => {
						this.total = result.total;
						//this.items = result.data.data
						this.setPreload(false);

						if (this.autoOpenSearch) {
							let match = this.getItems.find(el => el.buyer?.email?.toLowerCase() === this.autoOpenSearch.toLowerCase());
							this.autoOpenSearch = null;
							if (match) {
								this.editItem(match);
							}
						}
					})
					.then(() => {
						/*this.getFetchTreeCategory().then(() => {

                            var find =  _.orderBy(this.getCategoriesTree, 'parent.id', 'asc');

                            if(_.size(find)>0) {
                                if (_.size(find) > 1) {
                                    this.firstLevel = _.filter(this.getCategoriesTree, filter => {
                                        return filter.parent.id == find[0].parent.id
                                    })
                                    // console.log(this.firstLevel)
                                }

                                this.getNestedCategory(find[0].parent.id).then(() => {

                                    this.items = this.getCategoriesChildrean
                                })
                            }


                        })*/
					});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		closeSnackbar() {
			this.setSnackbar(false);
		},

		deleteItem(item) {
			this.dialogconfirm = true;
			this.form = item;
		},

		confirmDelete() {
			this.dialogconfirm = false;
			let url = 'customers/delete';

			this.messages = [];
			// il cliente scelto dai tre puntini (prima si eliminavano solo quelli spuntati,
			// e "Elimina" dalla riga senza spunte non mandava niente)
			const paypload = this.form && this.form._id ? _.filter(this.getItems, { _id: this.form._id }) : [];

			this.deleteItems(paypload)
				.then(data => {
					this.setPreload(false);
					this.getDataFromApi().then(res => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.customer-cards,
.customer-cards tr {
	display: block;
	width: 100%;
}
.customer-cards tr,
.customer-cards tr:hover {
	background: transparent !important;
}
.customer-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.customer-cards tr:first-child td {
	padding-top: 12px !important;
}
.customer-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.customer-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
